import React, { memo } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import { StoryblokLink } from '../../interfaces/StoryblokLink.interface';
import StoryblokLinkProvider from '../Utils/StoryblokLinkProvider/StoryblokLinkProvider';
import ButtonLink from '../ButtonLink/ButtonLink';
import { ButtonType } from '../../interfaces/enums/ButtonType.enum';
import { ButtonSize } from '../../interfaces/enums/ButtonSize.enum';
import { storyblokEditable } from 'gatsby-source-storyblok';

interface SecondaryCTABlokProps extends Blok {
  label: string;
  link: StoryblokLink;
  size?: ButtonSize;
}

interface SecondaryCTAProps {
  blok: SecondaryCTABlokProps;
}

const SecondaryCTA: React.FC<SecondaryCTAProps> = ({ blok }) => {
  const { label, link, size = ButtonSize.LG } = blok;
  return (
    <div {...storyblokEditable(blok)} className="w-full md:w-auto">
      <StoryblokLinkProvider
        link={link}
        render={(link: string) => (
          <ButtonLink
            url={link}
            label={label}
            type={ButtonType.SECONDARY}
            size={size}
            className="w-full md:w-auto"
          >
            {label}
          </ButtonLink>
        )}
      />
    </div>
  );
};

export default memo(SecondaryCTA);
